import { render, staticRenderFns } from "./CustomerTranslationNewPopup.vue?vue&type=template&id=6d792b24&"
import script from "./CustomerTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports